import { BrowserRouter } from "react-router-dom";
import { Suspense } from "react";
import { AppRoutes } from "./router";
import { CartProvider } from "./context/CartContext";

function App() {
  return (
    <BrowserRouter basename="/">
      <CartProvider>
        <Suspense fallback={
          <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center">
            <div className="text-center">
              <div className="text-6xl mb-4 animate-bounce">⚽</div>
              <p className="text-gray-600 text-lg">Carregando...</p>
            </div>
          </div>
        }>
          <AppRoutes />
        </Suspense>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
